import { INursingTaskSuggestion, IUser } from '@dokucoach/common-types';
import * as yup from 'yup';
import { IntervalType, NursingTaskType } from '../../../enums';
import { IOccurrence } from './IOccurrence';

export const NursingTaskSchema = yup.object({
  type: yup.string().required(),
  description: yup.string().notRequired().nullable(),
  startDate: yup.date().required(),
  endDate: yup.date().notRequired().nullable(),
  intervalNumber: yup.mixed().when('interval', {
    is: (v: string) => v === IntervalType.INTERVAL,
    then: yup.number().required('Angabe erforderlich'),
  }),
  weekdays: yup.mixed().when('interval', {
    is: (v: string) => v === IntervalType.WEEKDAYS,
    then: yup.object().shape({
      value: yup.array().min(1).of(yup.string()).required('Angabe erforderlich'),
    }),
  }),
  interval: yup.string().required(),
});

/**
 * An element of the type INursingTask should be created every time a corrensponding form is updated. Alternatively
 * a nursing task can be created inside the Task Overview Form (Monatsübersicht). All active nursing tasks
 * (or nursing tasks that have been active in the selected month) will be shown in the Task Overview Form.
 */
export type INursingTask = {
  /**
   * Type of the task
   */
  type: NursingTaskType;
  /**
   * Title of the Task (e.g. name of medication or wound name)
   */
  title?: string;
  /**
   * Additional information depending on task (e.g. detailed description of wound treatment), can be displayed as tooltip
   */
  description?: string;
  /**
   * First day the task is active
   */
  startDate: Date;
  /**
   * Last day the task is active
   */
  endDate?: Date | null;
  /**
   * Date until the task should not appear on the Dashboard (optional feature, out of scope)
   */
  endedAt?: Date | null;

  endedBy?: IUser;

  nursingTaskSuggestionId?: string | null;

  nursingTaskSuggestion?: INursingTaskSuggestion | null;

  pausedUntil?: Date;
  /**
   * A task can either be connected to a specific day of the week or occur every x days.
   * Using an interval occurrence a task will always be visible depending on its last documentation
   */
  occurrence: IOccurrence;
};

export type IUpdateNursingTask = Partial<INursingTask> & {
  id: string;
};
